const MODAL_MAX_WIDTH = '450px'

class ThingsToDo extends HTMLElement {
  constructor () {
    super()
    this.buttons = this.querySelectorAll('.things-to-do__item')
  }

  connectedCallback () {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        this.buildModal(button)
      })
    })
  }

  buildModal (button) {
    // Set loading state
    button.setAttribute('loading', '')

    const title = button.getAttribute('data-title')
    const description = button.getAttribute('data-description')
    const image = button.getAttribute('data-image')
    const location = button.getAttribute('data-location')
    const linkText = button.getAttribute('data-link-text')
    const linkUrl = button.getAttribute('data-link-url')
    const gmapsApiKey = button.getAttribute('data-gmaps-api-key')

    // Build Google Maps static image URL if location is provided
    const mapImageUrl = location ? `https://maps.googleapis.com/maps/api/staticmap?center=${location}&zoom=15&size=450x200&markers=${location}&key=${gmapsApiKey}` : null

    // Create and load images before showing modal
    const imagesToLoad = []

    if (image) {
      const img = new Image()
      img.src = image
      img.classList.add('w-full', 'h-75', 'object-cover', 'rounded-t-lg')
      imagesToLoad.push(img)
    }

    if (mapImageUrl) {
      const mapImg = new Image()
      mapImg.src = mapImageUrl
      mapImg.classList.add('w-full', 'rounded-lg')
      imagesToLoad.push(mapImg)
    }

    // Wait for all images to load
    Promise.all(imagesToLoad.map(img => {
      return new Promise((resolve, reject) => {
        img.onload = resolve
        img.onerror = reject
      })
    }))
      .then(() => {
        // Add a custom class for this specific modal instance
        const customClass = 'things-to-do-modal'

        // Open the modal with custom styling
        window.dispatchEvent(
          new CustomEvent('open:modal', {
            detail: {
              width: MODAL_MAX_WIDTH,
              padding: 'none',
              headerClassAdd: ['absolute', 'h-20', 'top-0', 'left-0', 'right-0', 'z-20'],
              headerClassRemove: ['border-b'],
              bodyClassAdd: ['relative', 'z-10'],
              closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20'],
              modalClassAdd: [customClass],
            },
          }),
        )

        // Wait for modal to be ready
        const checkModalReady = () => {
          const modal = document.querySelector('.reusable-modal')
          const modalBody = modal?.querySelector('.reusable-modal__body')

          if (!modalBody) {
            requestAnimationFrame(checkModalReady)
            return
          }

          // Add responsive styles for this specific modal instance
          if (!document.getElementById('things-to-do-modal-styles')) {
            const styleEl = document.createElement('style')
            styleEl.id = 'things-to-do-modal-styles'
            styleEl.textContent = `
              @media (max-width: 767px) {
                .${customClass} {
                  max-width: 100% !important;
                  width: 100% !important;
                  margin-left: 0 !important;
                  margin-right: 0 !important;
                  border-radius: 0 !important;
                }
              }
            `
            document.head.appendChild(styleEl)
          }

          const modalContent = `
            <div class="flex flex-col">
              ${image ? imagesToLoad[0].outerHTML : ''}
              <div class="flex flex-col gap-4 p-4">
                <h2 class="text-xl font-semibold">${title}</h2>
                <div class="tb-in-page-content">
                  ${description}
                </div>
              ${mapImageUrl
  ? `
                <div class="flex flex-col gap-2">
                  ${imagesToLoad[imagesToLoad.length - 1].outerHTML}
                </div>
              `
  : ''}
              ${linkUrl
  ? `
                <div>
                  <a href="${linkUrl}" target="_blank" rel="noopener noreferrer" class="button button-primary w-full px-6 py-1.5">
                    ${linkText || 'Learn More'}
                  </a>
                </div>
              `
  : ''}
              </div>
            </div>
          `

          modalBody.innerHTML = modalContent
          // Remove loading state after modal content is set
          button.removeAttribute('loading')
        }

        checkModalReady()
      })
      .catch(() => {
        // Remove loading state if any image fails to load
        button.removeAttribute('loading')
      })
  }
}

if (!customElements.get('things-to-do')) {
  customElements.define('things-to-do', ThingsToDo)
}
